export default __webpack_public_path__ + "static/media/blackWomen16.3f9afd07.svg";